import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { modeUsers } from "../../redux/services/user.service";
import { Button } from "react-bootstrap";
import SideBarMenu from "./sidebar";
import { performLogout } from "../../constants/logoutHelper";

const THEME_KEY = "themeMode";

const AdminLayout = () => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();
  const [sidebarActive, setSidebarActive] = useState(true);
  const [showBackdrop, setShowBackdrop] = useState(false);
  const [adminName, setAdminName] = useState("");
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || "light");

  const handleSidebar = () => setSidebarActive(!sidebarActive);
  useEffect(() => {
    setShowBackdrop(window.outerWidth <= 1200 && sidebarActive);
  }, [sidebarActive]);

  useEffect(() => {
    if (window.outerWidth <= 1200) setSidebarActive(false);
  }, [location.pathname]);

  useEffect(() => {
    if (user?.first_name) setAdminName(user.first_name);

    const handleResize = () => setSidebarActive(window.outerWidth > 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [user]);

  // Apply theme to body and html
  useEffect(() => {
    document.body.className = theme;
    document.documentElement.setAttribute("data-bs-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  // Update theme from user only if localStorage does not already have a theme
  useEffect(() => {
    if (user?.themeMode && !localStorage.getItem(THEME_KEY)) {
      setTheme(user.themeMode);
      const localStorageUser = JSON.parse(localStorage.getItem("user") || "{}");
      localStorageUser.themeMode = user.themeMode;
      localStorage.setItem("user", JSON.stringify(localStorageUser));
    }
  }, [user]);

  const toggleDarkTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);

    const localStorageUser = JSON.parse(localStorage.getItem("user") || "{}");
    localStorageUser.themeMode = newTheme;
    localStorage.setItem("user", JSON.stringify(localStorageUser));
    localStorage.setItem(THEME_KEY, newTheme);

    sendThemeToServer(newTheme);
  };

  const sendThemeToServer = (newTheme) => {
    modeUsers(newTheme).catch((err) => console.error("Error sending theme:", err));
  };

  const handleLogout = () => {
    performLogout(dispatch);
  };
  return (
    <>
      <div id="app">
        <div id="sidebar" className={sidebarActive ? "active" : "inactive"}>
          <div className="sidebar-wrapper active">
            <div className="sidebar-header position-relative">
              <div className="d-flex justify-content-between align-items-center">
                <div className="logo">
                  <Link to="/admin">Case Manager</Link>
                </div>
                <div className="sidebar-toggler">
                  <Link className="sidebar-hide d-xl-none d-block" onClick={handleSidebar}>
                    <i className="pi pi-times-circle"></i>
                  </Link>
                </div>
              </div>
            </div>
            <SideBarMenu />
          </div>
        </div>
        <div id="main" className="layout-navbar navbar-fixed">
          <header>
            <nav className="navbar navbar-expand navbar-light navbar-top border-bottom-custom p-2 h-unset">
              <div className="container-fluid flex-wrap gap-2">
                <Button className="p-2 d-inline-block" onClick={handleSidebar}>
                  <i className="pi pi-align-justify fs-4 d-flex align-items-center justify-content-center h-100"></i>
                </Button>

                <div
                  className="collapse navbar-collapse justify-content-lg-end justify-content-sm-between justify-content-between gap-3"
                  id="navbarSupportedContent">
                  {/* Notification & theme toggle */}
                  <ul className="navbar-nav ms-auto mb-lg-0">{/* Notifications */}</ul>

                  <div className="mode m-0">
                    <div className="form-check form-switch fs-6">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={theme === "dark"}
                        onChange={toggleDarkTheme}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        htmlFor="darkModeSwitch"
                        className="form-check-label"
                        style={{ cursor: "pointer", fontSize: "20px" }}>
                        {theme === "dark" ? (
                          <i className="bi bi-moon"></i>
                        ) : (
                          <i className="bi bi-brightness-high"></i>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* User menu */}
                  <div className="dropdown">
                    <a href="/admin" data-bs-toggle="dropdown" aria-expanded="false">
                      <div className="user-menu d-flex">
                        <div className="user-name text-end me-3">
                          <h6 className="mb-0 text-gray-600">{adminName}</h6>
                          <p className="mb-0 text-sm text-gray-600">Admin</p>
                        </div>
                        <div className="user-img align-items-center text-gray-600">
                          <i className="pi pi-user fs-4"></i>
                        </div>
                      </div>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end" style={{ minWidth: "11rem" }}>
                      <li>
                        <h6 className="dropdown-header">Hello, {adminName}!</h6>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/profile">
                          <i className="icon-mid pi pi-user me-2"></i> My Profile
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/change-password">
                          <i className="icon-mid pi pi-key me-2"></i> Change Password
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <Link className="dropdown-item" onClick={handleLogout}>
                          <i className="icon-mid pi pi-arrow-left me-2"></i> Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </header>
          <div id="main-content">
            <Outlet />
          </div>
          <footer></footer>
        </div>
      </div>

      <div
        className="sidebar-backdrop"
        style={{ display: showBackdrop ? "block" : "none" }}
        onClick={handleSidebar}></div>
    </>
  );
};

export default AdminLayout;
